export function safeLoreReturnPath(raw: string | null): string | null {
  if (!raw) return null
  if (raw.startsWith('//') || raw.includes('\\')) return null
  if (raw === '/lore/organization-operation') {
    return raw
  }
  if (raw.startsWith('/lore/authorize?')) return raw
  return isDesktopAuthorizationPath(raw) ? raw : null
}

function isDesktopAuthorizationPath(raw: string): boolean {
  if (!raw.startsWith('/desktop/authorize?')) return false
  const url = new URL(raw, 'https://local.archigma.invalid')
  const entries = Array.from(url.searchParams.entries())
  if (
    url.pathname !== '/desktop/authorize' ||
    entries.length !== 2 ||
    !url.searchParams.has('attempt_id') ||
    !url.searchParams.has('state')
  ) {
    return false
  }
  const attemptId = url.searchParams.get('attempt_id') ?? ''
  const state = url.searchParams.get('state') ?? ''
  return (
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
      attemptId,
    ) &&
    state.length >= 43 &&
    state.length <= 128 &&
    /^[A-Za-z0-9._~-]+$/.test(state)
  )
}

interface LoreOrganization {
  id: string
}

/**
 * Resolve the organization that should own an interactive LORE session.
 * An existing JWT scope wins. With no active scope, one membership is
 * unambiguous; multiple memberships require an explicit valid selection.
 */
export function loreOrganizationToAuthorize(
  activeOrganizationId: string | null,
  selectedOrganizationId: string,
  organizations: LoreOrganization[],
): string | null {
  if (activeOrganizationId) return activeOrganizationId
  if (
    selectedOrganizationId &&
    organizations.some(
      (organization) => organization.id === selectedOrganizationId,
    )
  ) {
    return selectedOrganizationId
  }
  return organizations.length === 1 ? organizations[0].id : null
}

function isOrganizationOperationCode(value: string | null): value is string {
  return value?.length === 43 && /^[A-Za-z0-9_-]+$/.test(value)
}

export function loreOrganizationOperationCode(
  rawHash: string,
  storedCode: string | null,
): string | null {
  const fragmentEntries = Array.from(
    new URLSearchParams(rawHash.replace(/^#/, '')).entries(),
  )
  const fragmentCode =
    fragmentEntries.length === 1 && fragmentEntries[0][0] === 'code'
      ? fragmentEntries[0][1]
      : null
  if (isOrganizationOperationCode(fragmentCode)) {
    return fragmentCode
  }
  return isOrganizationOperationCode(storedCode) ? storedCode : null
}
